<template>
  <div>
    <v-card class="main pa-2">
      <v-toolbar dense flat>
        <v-toolbar-title class="body-2 beez-bold">
          Failed Login Attempts
        </v-toolbar-title>
        <v-spacer />
        <v-tooltip bottom>
          <v-btn slot="activator" :loading="loader" flat icon @click="getData">
            <v-icon>
              refresh
            </v-icon>
          </v-btn>
          <span>Refresh</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-text-field v-model="search" color="secondary" label="Search">
        </v-text-field>
        <v-data-table
          :search="search"
          :headers="headers"
          :items="items"
          :loading="loader"
          :pagination.sync="pagination"
          :rows-per-page-items="headerPageItems"
          item-key="userHexId"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left">{{ props.item.sessionId }}</td>
              <td class="text-xs-left">{{ props.item.principal }}</td>
              <td class="text-xs-left">{{ props.item.attempts }}</td>
              <td class="text-xs-left">{{ props.item.ipAddress }}</td>
              <td class="text-xs-left">
                {{ getLocalTime(props.item.lastAttempt) }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'SyncUpFix',
  data() {
    return {
      loader: false,
      items: [],
      search: '',
      headerPageItems: [5, 10, 25, { text: 'All', value: -1 }],
      pagination: {
        sortBy: 'lastAttempt',
        rowsPerPage: 10,
        descending: true,
        totalItems: 0,
        page: 1
      },
      headers: [
        {
          text: 'ID',
          align: 'left',
          value: 'sessionId',
          sortable: false
        },
        { text: 'Principal', value: 'principal' },
        { text: 'No. of Attempts', value: 'attempts' },
        { text: 'IP address', value: 'ipAddress' },
        { text: 'Last Attempted at', value: 'lastAttempt' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      can: 'can'
    })
  },
  watch: {},
  mounted() {
    this.getData()
  },
  methods: {
    getLocalTime(input) {
      return moment(input)
        .utc()
        .local()
        .format('DD MMM YYYY, hh:mm:ss a')
    },
    async getData() {
      this.loader = true
      axios
        .get('/api/core/maintain/clients/failedAttempts')
        .then(response => {
          this.items = response.data
          this.loader = false
        })
        .catch(error => {
          this.loader = false
          console.log(error)
        })
    }
  }
}
</script>

<style scoped></style>
